module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Noni Ledesma', // Navigation and Site Title
  siteTitleAlt: 'Noni Ledesma - Portfolio', // Alternative Site title for SEO
  siteUrl: 'https://noniledesma.netlify.com', // Domain of your site. No trailing slash!
  siteLanguage: 'es', // Language Tag on <html> element
  siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
  siteDescription: 'Noni Ledesma Artista Plástica',

  siteFBAppID: '', // Facebook App ID
  userTwitter: '', // Twitter Username
  ogSiteName: '', // Facebook Site Name
  ogLanguage: '', // og:language
  googleAnalyticsID: 'UA-116429757-1',
  
  // Manifest and Progress color
  themeColor: '#3498DB',
  backgroundColor: '#2b2e3c',

  // Settings for typography.js
  headerFontFamily: 'Open Sans',
  bodyFontFamily: 'Space Mono',
  baseFontSize: '16px',

  // Your information
  avatar: '/logos/caripela.jpg',
  name: 'Noni Ledesma',
  location: 'Artista Plástica, Seleccionada en Libro de Artistas Flamantes #13',
  socialMedia: [
    
    {
      url: 'https://www.instagram.com/la_pintadora' ,
      name: 'Instagram',
    },
    {
      url: 'https://www.hagocosas.es/flamantes.html',
      name: 'Flamantes',
    },
  ],
};



// WEBPACK FOOTER //
// ./config/site.js